import { makeVar } from '@apollo/client';
import { getItem } from '@cvent/apollo-client/utils/storage';
import { defaultLocale } from '@cvent/universal-login-web-localization/locale';
import { LOCALE_COOKIE } from '@cvent/universal-login-web-middleware';

import { getCookie } from '@utils/RequestHelpers';

// To learn more options for local state management go here; https://www.apollographql.com/blog/local-state-management-with-reactive-variables/
export const darkModeVar = makeVar<boolean>(false);
export const clientVersion = makeVar<string>(String(process.env.CLIENT_VERSION) || 'unknown');
export const localeVar = makeVar<string>(getCookie(LOCALE_COOKIE) || getItem('locale') || defaultLocale);
export const titleVar = makeVar<string>(null);
export const hasInitDatadog = makeVar<boolean>(false);
